





























































































































import { http } from '@/services';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PackagesHome extends Vue {
  protected packages: Array<any> = [];
  protected products: Array<any> = [];
  protected newPackage = {
    name: '',
    description: '',
    products: [],
    quantities: [],
  };
  protected showDialog: boolean = false;
  protected isValid: boolean = false;
  protected rules = {
    name: [
      (name: string) =>
        (name.trim().length >= 3 && name.trim().length <= 60) ||
        'O nome deve conter no mínimo 3 e no máximo 60 caracteres.',
    ],
    description: [
      (description: string) =>
        (description.trim().length === 0 || description.trim().length <= 150) ||
        'A descrição deve conter no máximo 150 caracteres.',
    ],
    products: [
      (products: Array<any>) =>
        products.length > 0 ||
        'Selecione pelo menos um produto para compor o pacote.',
    ],
  };

  protected async mounted(): Promise<void> {
    this.packages.push(...(await http.get('/packages')).data);
    this.products.push(...(await http.get('/products')).data);
  }

  protected async save(): Promise<void> {
    const data = {
      name: this.newPackage.name,
      description: this.newPackage.description,
      products: new Array(this.newPackage.products.length),
    };
    this.newPackage.products.forEach((productId, index) => {
      data.products[index] = { id: productId, quantity: this.newPackage.quantities[index] };
    });

    await http.post('/packages', data);
    this.packages.splice(0);
    this.packages.push(...(await http.get('/packages')).data);
    this.showDialog = false;
    this.resetModel();
  }

  protected resetModel(): void {
    this.newPackage.name = '';
    this.newPackage.description = '';
    this.newPackage.products = [];
    this.newPackage.quantities = [];
  }
}
